import styled from "@emotion/styled";

export const StatusWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const StatusText = styled.span`
    color: #fff;
    font-size: 16px;
`;

export const SvgWrapper = styled.svg`
    width: 40px;
    height: 40px;
    flex: 0 0 auto;
`;

export const TrackCircle = styled.circle`
  fill: none;
  stroke: rgba(255, 255, 255, 0.12);
  stroke-width: 8;
`;

export const ProgressCircle = styled.circle`
  fill: none;
  stroke-width: 8;
`;